import { render } from "./DashboardAtencion.vue?vue&type=template&id=e4533a9a"
import script from "./DashboardAtencion.vue?vue&type=script&lang=js"
export * from "./DashboardAtencion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__